import React, { useEffect, useState } from 'react'
import { List } from '../../organization/components'
import { ArrayChecker, SearchInput } from '../../../components'
import { useOrganizations } from '../../../features/organizations'
import { useSelector } from 'react-redux'

const ListOrganization = () => {
  const [keyword, setKeyword] = useState('')
  const [mainData, setMainData] = useState([])
  const [data, setData] = useState([])
  const { organizations } = useOrganizations()
  const { organizations: individuData } = useSelector(state => state.individu.data_bookmark)
  const { isIndividu } = useSelector(state => state.account)

  useEffect(() => {
    if(isIndividu && individuData){
      setMainData(individuData)
      setData(individuData)
    } else {
      setMainData(organizations)
      setData(organizations)
    }
  }, [individuData, isIndividu, organizations])

  const handleSubmit = () => {
    if(!keyword || keyword === ''){
      setData(mainData)
    } else {
      setData(mainData.filter(d => d.name.toLowerCase().includes(keyword.toLowerCase())))
    }
  }

  const handleChange = (e) => {
    if(e && e.target){
      setKeyword(e.target.value)
    }
  }

  return (
    <>
      <div className="w-full xl:w-6/12 mb-5 lg:mb-10">
        <SearchInput onChange={handleChange} onSearchSubmit={handleSubmit}/>
      </div>
      <ArrayChecker data={data}>
        <List data={data} bookmark={true}/>
      </ArrayChecker>
    </>
  )
}

export { ListOrganization }
